export default __webpack_public_path__ + "static/media/DPE_F.c829e5bd.png";